'use client';
import { useGoogleAnalytics } from '@/lib/analytics';

export default function GoogleAnalytics() {
  useGoogleAnalytics();
  return null;
}
